import * as mrCap from '../mrCapTypes';
export * from './product/viewProductSelection';
export * from './location/viewLocation';
export * from './location/viewLocationAndDate';
export * from './payment/viewConfirm';
export * from './summary/viewSummary';

/** Common shared props for all views */
export interface ViewProp {
  regNr?: string;
  selectedProducts: mrCap.Product[];
  selectedShop: mrCap.Shop | null;
  selectedDate: Date | null;
  selectedMabi?: string | null;
  texts: mrCap.BookingFormTexts;
  ecster: mrCap.EcsterConfig;
  financing: boolean;
  financingTypes: mrCap.BookingType[];
  carDetails?: mrCap.VehicleInfo;
  booking: mrCap.BookingRequest;
  shipping: number;
  onSiteOk: boolean;
  campaign?: mrCap.CampaignResponse;
  mabi: mrCap.MabiBooking | null;
  weightThreshold: number;
  initialFilterArticleGroup: string;

  /** Booking order id */
  bookingId: string;

  toggleProduct: (product: mrCap.Product) => void;
  updateProduct: (artNr: string, noi: number) => void;
  setRegNr: (regNr: string) => void;
  setShop: (shop: mrCap.Shop) => void;
  setDate: (selectedDate: Date | null) => void;
  moveNext: (force?: boolean) => void;
  togglePayment: () => void;
  setCarDetails: (carDetails: mrCap.VehicleInfo | undefined) => void;
  setBookingDetails: (booking: mrCap.BookingRequest) => void;
  setOk: (onSiteOk: boolean) => void;
  setCampaign: (campaign: mrCap.CampaignResponse) => void;
  setMabi: (vehicle: string) => void;
  updateSelectedProducts: (products: mrCap.Product[]) => void;
}

export const globalStrings = {
  zeroPrice: 'Pris meddelas på plats'
};